/* eslint-disable no-undef */
const CryptoJS = require('crypto-js')
const supplyCode = CryptoJS.AES.decrypt(
  window.config,
  '3376E34B3B0A7F1C',
).toString(CryptoJS.enc.Utf8)
export default {
  supplyCode,
  imgSrc: 'https://itms-officialwebsite-dev.oss-cn-shenzhen.aliyuncs.com/',
  menuCode: {
    SY: 'SY', // 首页
    GZT: 'GZT', // 工作台
    XTSZ: 'XTSZ', // 系统设置
    YHGL: 'YHGL', // 用户管理
    JSQX: 'JSQX', // 角色权限
    SHYH: 'SHYH', // 审核用户
    KHGL: 'KHGL', // 客户管理
    HLSZ: 'HLSZ', // 汇率设置
    GDSZ: 'GDSZ', // 工单设置
    ZDSZ: 'ZDSZ', // 制单设置
    ZDCX: 'ZDCX', // 账单查询
    SF: 'SF', // 账单查询
    YFGL: 'YFGL', // 应付管理
    YSGL: 'YSGL', // 应收管理
    PSDZ: 'PSDZ', // 派送对账
    CZSD: 'CZSD', // 充值水单
    FYCX: 'FYCX', // 费用查询
    KHZHGL: 'KHZHGL', // 客户账户管理
    SKZHGL: 'SKZHGL', // 收款账户管理
    FYDMGL: 'FYDMGL', // 费用代码管理
    CWGL: 'CWGL', // 财务管理
    GYSGL: 'GYSGL', // 供应商管理
    DDGL: 'DDGL', // 订单管理
    DDCX: 'DDCX', // 订单查询
    GJCX: 'GJCX', // 轨迹查询
    FYSS: 'FYSS', // 费用试算
    BTKD: 'BTKD', // 本土快递
    GJKD: 'GJKD', // 国际快递
    KP: 'KP', // 卡派
    YGFYCX: 'YGFYCX', // 预估费用查询
    TDGL: 'TDGL', // 提单管理
    TDSZ: 'TDSZ', // 提单设置
    KYTD: 'KYTD', // 空运提单
    HYTD: 'HYTD', // 海运提单
    ISF: 'ISF', // ISF
    PDF: 'PDF', // PDF
    SLK: 'SLK', // 税率库
    CPK: 'CPK', // 产品库
    KPLB: 'KPLB', // 卡派列表,
    SMHD: 'SMHD', // 扫码换单
    JCZL: 'JCZL', // 基础资料
    GD: 'GD', // 工单
    MLTJ: 'MLTJ', // 毛利统计
    CYLB: 'CYLB', // 查验列表
    TJFX: 'TJFX', // 统计分析
    YYBB: 'YYBB', // 运营报表
    KPXJ: 'KPXJ', // 卡派询价
    QTYW: 'QTYW', // 其他业务
    KCSP: 'KCSP', // 开查索赔
    BBGG: 'BBGG', // 版本公告
    CJTD: 'CJTD', // 创建提单
    ZSLB: 'ZSLB', // 直送列表
    HX: 'HX', // 核销
    QGZX: 'QGZX', // 清关咨询
    YBGL: 'YBGL', // 预报管理
    JKSGL: 'JKSGL', // 进口商管理
    DZGL: 'DZGL', // 单证管理
    TAXM: 'TAXM', // 7501
    ANDO: 'ANDO', // AN/DO
    INVOICE: 'INVOICE', // 发票管理
    ENTRY: 'ENTRY', // Entry
    YJZX: 'YJZX', // 邮件中心
    YJSZ: 'YJSZ' // 邮件设置
  },
  userTypeOption: [
    {
      value: 100,
      label: '操作'
    },
    {
      value: 101,
      label: '财务'
    },
    {
      value: 102,
      label: '销售'
    },
    {
      value: 103,
      label: '客服'
    },
    {
      value: 106,
      label: '公司领导'
    },
    {
      value: 109,
      label: '外部人员'
    },
    {
      value: 166,
      label: '管理员'
    }
  ],
  dimensionOptions: [
    {
      value: 0,
      label: '英寸'
    },
    {
      value: 1,
      label: '厘米'
    }
    // {
    //   value: 2,
    //   label: '厘米'
    // }
  ],
  calculateOptions: [
    {
      value: 0,
      label: '单价-按件'
    },
    {
      value: 1,
      label: '单价-按票'
    },
    {
      value: 2,
      label: '固定价-按件'
    },
    {
      value: 3,
      label: '固定价-按票'
    }
  ],
  weightUnitOptions: [
    {
      value: 0,
      label: '英镑'
    },
    {
      value: 1,
      label: '千克'
    }
  ],
  limitTypeOptions: [
    {
      value: 1,
      label: '限重'
    },
    {
      value: 2,
      label: '限额'
    }
  ],
  // 优先级(0-9，0最高)
  calculateLevelOptions: [
    {
      value: 0,
      label: 0
    },
    {
      value: 1,
      label: 1
    },
    {
      value: 2,
      label: 2
    },
    {
      value: 3,
      label: 3
    },
    {
      value: 4,
      label: 4
    },
    {
      value: 5,
      label: 5
    },
    {
      value: 6,
      label: 6
    },
    {
      value: 7,
      label: 7
    },
    {
      value: 8,
      label: 8
    },
    {
      value: 9,
      label: 9
    }
  ],
  // 计算方式
  calculateTypelOptions: [
    {
      value: 0,
      label: '按票'
    },
    {
      value: 1,
      label: '按件'
    }
  ],
  // 账号附加费计算维度
  caculateDimensionOptions: [
    {
      value: 0,
      label: '不限'
    },
    {
      value: 1,
      label: '分区'
    }
  ],
  // 限额
  unitsCodeOptions: [
    {
      value: 'RMB',
      label: 'RMB'
    },
    {
      value: 'USD',
      label: 'USD'
    },
    {
      value: 'KG',
      label: 'KG'
    },
    {
      value: 'LB',
      label: 'LB'
    },
    {
      value: 'GBP',
      label: 'GBP'
    },
    {
      value: 'HKD',
      label: 'HKD'
    }
  ],
  typeOptions: [
    {
      value: 0,
      label: '邮编'
    },
    {
      value: 1,
      label: '国家代码'
    }
  ],
  accountPriceTplOptions: [
    {
      value: 0,
      label: '不限'
    },
    {
      value: 1,
      label: '住宅'
    },
    {
      value: 2,
      label: '商业'
    }
  ],
  // 水单类型
  waterBillType: [
    {
      value: 0,
      label: '待审核'
    },
    {
      value: 1,
      label: '审核通过'
    },
    {
      value: 2,
      label: '已到账'
    },
    {
      value: -2,
      label: '退回'
    },
    {
      value: -1,
      label: '审核不通过'
    }
  ],
  orderStatusOptions: [
    {
      value: 10000,
      label: '全部',
      permissson: 'QB'
    },
    {
      value: 0,
      label: '待上传',
      permissson: 'DSC'
    },
    {
      value: 1,
      label: '待上网',
      permissson: 'DSW'
    },
    {
      value: 2,
      label: '运输中',
      permissson: 'YSZ'
    },
    {
      value: 3,
      label: '签收',
      permissson: 'QS'
    },
    {
      value: 4,
      label: '退回',
      permissson: 'TH'
    },
    {
      value: 10,
      label: '非系统制单',
      permissson: 'FXTZD'
    },
    {
      value: -1,
      label: '取消',
      permissson: 'QX'
    }
  ],
  expressSupplierOptions: [
    {
      value: 'UPS',
      label: 'UPS'
    },
    {
      value: 'FedEx',
      label: 'FedEx'
    }
    // {
    //   value: 'DHL',
    //   label: 'DHL'
    // },
    // {
    //   value: 'DPD',
    //   label: 'DPD'
    // },
    // {
    //   value: 'FEEPOWER',
    //   label: 'FEEPOWER'
    // }
  ],
  originCountryOptions: [
    {
      label: 'Los Angeles',
      value: 3403
    },
    {
      label: 'Chicago',
      value: 3424
    },
    {
      label: 'New York',
      value: 3451
    },
    {
      label: 'Dallas',
      value: 3426
    },
    {
      label: 'Seattle',
      value: 3778
    },
    {
      label: 'San Francisco',
      value: 3779
    },
    {
      label: 'Oakland',
      value: 3420
    }
  ],
  expressServiceOptions: [
    {
      value: 'Ground',
      label: 'Ground'
    },
    {
      value: 'MWT',
      label: 'MWT'
    },
    {
      value: 'GFP',
      label: 'GFP'
    },
    {
      value: 'HundredWeight',
      label: 'HundredWeight'
    },
    {
      value: 'Truck',
      label: 'Truck'
    }
  ],
  billTypeOptions: [
    {
      value: 0,
      label: '直单'
    },
    {
      value: 1,
      label: '分单'
    }
  ],
  billStatusOptions: [
    {
      value: '',
      label: '全部',
      permissson: 'QB'
    },
    {
      value: 0,
      label: '待处理',
      permissson: 'DCL'
    },
    {
      value: 1,
      label: '处理中',
      permissson: 'QGZ'
    },
    // {
    //   value: 2,
    //   label: '提拆交',
    //   permissson: 'TCJ'
    // },
    {
      value: 3,
      label: '作废',
      permissson: 'YC'
    },
    {
      value: 4,
      label: '完结',
      permissson: 'WJ'
    }
  ],
  billShipSubtabOptions: [
    [
      // {
      //   value: 0,
      //   label: '未发送'
      // },
      {
        value: 1,
        label: '待确认'
      }
      // {
      //   value: 1000,
      //   label: '拒绝'
      // }
    ],
    [
      {
        value: 2,
        label: '待发预报'
      },
      // {
      //   value: 3,
      //   label: '预报已发送'
      // },
      // {
      //   value: 4,
      //   label: '预报已接受'
      // },
      {
        value: 5,
        label: '税金待确认'
      },
      {
        value: 6,
        label: '清关中'
      },
      {
        value: 7,
        label: '查验中'
      },
      {
        value: 8,
        label: '已放行'
      }
    ],
    [
      {
        value: 100,
        label: '运输中'
      },
      {
        value: 101,
        label: '到港'
      },
      {
        value: 102,
        label: '卸船'
      },
      // {
      //   value: 103,
      //   label: '预约'
      // },
      {
        value: 104,
        label: '提柜'
      },
      {
        value: 105,
        label: '到仓出仓'
      },
      {
        value: 106,
        label: '出仓完成'
      },
      {
        value: 107,
        label: 'HOLD'
      }
    ],
    [
      {
        value: 1000,
        label: '拒绝'
      },
      {
        value: 1002,
        label: '作废'
      }
    ],
    [
      {
        value: 10000,
        label: '完结'
      }
    ]
  ],
  billAirSubtabOptions: [
    [
      // {
      //   value: 0,
      //   label: '未发送'
      // },
      {
        value: 1,
        label: '待确认'
      }
      // {
      //   value: 1000,
      //   label: '拒绝'
      // }
    ],
    [
      {
        value: 2,
        label: '待发预报'
      },
      // {
      //   value: 3,
      //   label: '预报已发送'
      // },
      // {
      //   value: 4,
      //   label: '预报已接受'
      // },
      {
        value: 5,
        label: '税金待确认'
      },
      {
        value: 6,
        label: '清关中'
      },
      {
        value: 7,
        label: '查验中'
      },
      {
        value: 8,
        label: '已放行'
      }
    ],
    [
      {
        value: 100,
        label: '运输中'
      },
      {
        value: 105,
        label: '到仓出仓'
      },
      {
        value: 106,
        label: '出仓完成'
      },
      {
        value: 107,
        label: 'HOLD'
      }
    ],
    [
      {
        value: 1000,
        label: '拒绝'
      },
      {
        value: 1002,
        label: '作废'
      }
    ],
    [
      {
        value: 10000,
        label: '完结'
      }
    ]
  ],
  clearenceTypeOptions: [
    {
      value: 0,
      label: '自清'
    },
    {
      value: 1,
      label: '平台清'
    }
  ],
  pickUpTypeOptions: [
    {
      value: 0,
      label: '自提'
    },
    {
      value: 1,
      label: '直送'
    },
    {
      value: 2,
      label: '回仓'
    }
  ],
  isfStatusOptions: [
    {
      value: 0,
      label: '未填报'
    },
    {
      value: 1,
      label: '未发送',
      permissson: 'WFS'
    },
    {
      value: 2,
      label: '未接受',
      permissson: 'WJS'
    },
    {
      value: 3,
      label: '已接受',
      permissson: 'YJS'
    },
    {
      value: 4,
      label: 'OnFile',
      permissson: 'ONFILE'
    },
    {
      value: 5,
      label: 'NotOnFile',
      permissson: 'NOTONFILE'
    },
    {
      value: 6,
      label: '取消',
      permissson: 'QX'
    },
    {
      value: -1,
      label: 'NA'
    }
  ],
  bondTypeOptions: [
    {
      value: 0,
      label: 'AnnualBond'
    },
    {
      value: 1,
      label: 'SingleBond'
    }
  ],
  billNumberTypeOptions: [
    {
      value: 0,
      label: 'Regular bill/staight bill'
    },
    {
      value: 1,
      label: 'House bill'
    }
  ],
  billShipOptOptions: [
    [
      {
        name: '跟进记录',
        permissson: 'uploadLog',
        btnImg: 'updateLog',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [
      {
        name: '确认',
        permissson: 'sure',
        class: { link: 'link' },
        event: { eventName: 'checkBill', options: [0] },
        vIf: function() {
          return true
        }
      },
      {
        name: '拒绝',
        permissson: 'refuse',
        class: { link: 'link' },
        event: { eventName: 'checkBill', options: [1] },
        vIf: function() {
          return true
        }
      },
      {
        name: '修改',
        permissson: 'assign_followers',
        class: { link: 'link2' },
        event: { eventName: 'assignFollowers', options: [] },
        vIf: function() {
          return true
        }
      },
      // {
      //   name: '装载',
      //   permissson: 'loadOrder',
      //   class: { link: 'link' },
      //   event: { eventName: 'loadOrder', options: [] },
      //   vIf: function(row) {
      //     if (row.isOnLoad) return true
      //     return false
      //   }
      // },
      {
        name: '作废',
        permissson: 'void',
        class: { link: 'link' },
        event: { eventName: 'handleVoid', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '跟进记录',
        permissson: 'uploadLog',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [
      // {
      //   name: '审核',
      //   permissson: 'audit_b',
      //   class: { link: 'link2' },
      //   event: { eventName: 'audit', options: [] },
      //   vIf: function(row) {
      //     if (row.clearenceStatus === 3) return true
      //     return false
      //   }
      // },
      // {
      //   name: '装载',
      //   permissson: 'loadOrder',
      //   class: { link: 'link2' },
      //   event: { eventName: 'loadOrder', options: [] },
      //   vIf: function(row) {
      //     if (row.isOnLoad) return true
      //     return false
      //   }
      // },
      {
        name: '作废',
        permissson: 'void',
        class: { link: 'link2' },
        event: { eventName: 'handleVoid', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '上传预报',
        permissson: 'upload_mainifest',
        class: { link: 'link2' },
        event: { eventName: 'uploadManifest', options: [] },
        vIf: function(row) {
          if (row.forecastStatus === 0 && row.clearenceType !== 0) return true
          return false
        }
      },
      {
        name: '重新上传预报',
        permissson: 'upload_mainifest',
        class: { link: 'link2' },
        event: { eventName: 'uploadManifest', options: [] },
        vIf: function(row) {
          if (row.forecastStatus === 10 && row.clearenceType !== 0) return true
          return false
        }
      },
      // {
      //   name: '驳回',
      //   permissson: 'reject',
      //   class: { link: 'link2' },
      //   event: { eventName: 'rejectdAttachment', options: [] },
      //   vIf: function(row) {
      //     if (row.forecastStatus === 1) return true
      //     return false
      //   }
      // },
      {
        name: '修改',
        permissson: 'assign_followers',
        class: { link: 'link2' },
        event: { eventName: 'assignFollowers', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '上传税金单',
        permissson: 'upload',
        class: { link: 'link2' },
        event: { eventName: 'uploadAttachment', options: [] },
        vIf: function(row) {
          if (row.clearenceStatus === 4 || row.clearenceStatus === 7) {
            return true
          }
          return false
        }
      },
      {
        name: '完结',
        permissson: 'over',
        class: { link: 'link2' },
        event: { eventName: 'over', options: [] },
        vIf: function() {
          // if ((row.clearenceType === 1 && row.clearenceStatus === 8 && row.pickUpType === 0) || (row.pickUpSplitDeliveryStatus === 106 && row.pickUpType === 1)) return true
          // return false
          return true
        }
      },
      {
        name: '跟进记录',
        permissson: 'uploadLog',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '上传附件',
        permissson: 'upload',
        class: { link: 'link' },
        event: { eventName: 'uploadAttachment', options: [] },
        vIf: function() {
          return true
        }
      },
      // {
      //   name: '到港',
      //   permissson: 'arrivalPort',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showDateTime', options: ['到港'] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 100) return true
      //     return false
      //   }
      // },
      // {
      //   name: '卸船',
      //   permissson: 'DischargeShip',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showDateTime', options: ['卸船'] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 101) return true
      //     return false
      //   }
      // },
      // {
      //   name: '预约',
      //   permissson: 'subscribe',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showAppointment', options: [] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 102) return true
      //     return false
      //   }
      // },
      // {
      //   name: '到达',
      //   permissson: 'arrive',
      //   class: { link: 'link2' },
      //   event: { eventName: 'arrive', options: [] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 103) return true
      //     return false
      //   }
      // },
      // {
      //   name: '到仓',
      //   permissson: 'ArrivalWarehouse',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showWarehouse', options: ['0'] },
      //   vIf: function(row) {
      //     if (
      //       row.pickUpSplitDeliveryStatus === 105 ||
      //       row.pickUpSplitDeliveryStatus === 106
      //     ) { return true }
      //     return false
      //   }
      // },
      // {
      //   name: '出仓',
      //   permissson: 'OutWarehouse',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showWarehouse', options: ['1'] },
      //   vIf: function(row) {
      //     if (
      //       row.pickUpSplitDeliveryStatus === 105 ||
      //       row.pickUpSplitDeliveryStatus === 106
      //     ) { return true }
      //     return false
      //   }
      // },
      {
        name: 'release',
        permissson: 'release',
        class: { link: 'link2' },
        event: { eventName: 'release', options: ['1'] },
        vIf: function(row) {
          if (row.pickUpSplitDeliveryStatus === 107) return true
          return false
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [],
    [
      {
        name: '还原',
        permissson: 'restore',
        class: { link: 'link' },
        event: { eventName: 'handleRestore', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '删除',
        permissson: 'delete',
        class: { link: 'link' },
        event: { eventName: 'handleDelete', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '跟进记录',
        permissson: 'uploadLog',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [
      {
        name: '跟进记录',
        permissson: 'uploadLog',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ]
  ],
  billAirOptOptions: [
    [
      {
        name: '跟进记录',
        permissson: 'uploadLog',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [
      // {
      //   name: '装载',
      //   permissson: 'loadOrder',
      //   class: { link: 'link' },
      //   event: { eventName: 'loadOrder', options: [] },
      //   vIf: function(row) {
      //     if (row.isOnLoad) return true
      //     return false
      //   }
      // },
      {
        name: '修改',
        permissson: 'assign_followers',
        class: { link: 'link2' },
        event: { eventName: 'assignFollowers', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '作废',
        permissson: 'void_a',
        class: { link: 'link' },
        event: { eventName: 'handleVoid', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '跟进记录',
        permissson: 'uploadLog_a',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '确认',
        permissson: 'sure',
        class: { link: 'link' },
        event: { eventName: 'checkBill', options: [0] },
        vIf: function() {
          return true
        }
      },
      {
        name: '拒绝',
        permissson: 'refuse',
        class: { link: 'link' },
        event: { eventName: 'checkBill', options: [1] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [
      // {
      //   name: '审核',
      //   permissson: 'audit_b',
      //   class: { link: 'link2' },
      //   event: { eventName: 'audit', options: [] },
      //   vIf: function(row) {
      //     if (row.clearenceStatus === 3) return true
      //     return false
      //   }
      // },
      // {
      //   name: '装载',
      //   permissson: 'loadOrder',
      //   class: { link: 'link2' },
      //   event: { eventName: 'loadOrder', options: [] },
      //   vIf: function(row) {
      //     if (row.isOnLoad) return true
      //     return false
      //   }
      // },
      {
        name: '作废',
        permissson: 'void_b',
        class: { link: 'link2' },
        event: { eventName: 'handleVoid', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '上传预报',
        permissson: 'upload_mainifest',
        class: { link: 'link2' },
        event: { eventName: 'uploadManifest', options: [] },
        vIf: function(row) {
          if (row.forecastStatus === 0 && row.clearenceType !== 0) return true
          return false
        }
      },
      {
        name: '重新上传预报',
        permissson: 'upload_mainifest',
        class: { link: 'link2' },
        event: { eventName: 'uploadManifest', options: [] },
        vIf: function(row) {
          if (row.forecastStatus === 10 && row.clearenceType !== 0) return true
          return false
        }
      },
      // {
      //   name: '驳回',
      //   permissson: 'reject',
      //   class: { link: 'link2' },
      //   event: { eventName: 'rejectdAttachment', options: [] },
      //   vIf: function(row) {
      //     if (row.clearenceStatus === 4) return true
      //     return false
      //   }
      // },
      {
        name: '修改',
        permissson: 'assign_followers',
        class: { link: 'link2' },
        event: { eventName: 'assignFollowers', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '上传税金单',
        permissson: 'upload_b',
        class: { link: 'link2' },
        event: { eventName: 'uploadAttachment', options: [] },
        vIf: function(row) {
          if (row.clearenceStatus === 4 || row.clearenceStatus === 7) {
            return true
          }
          return false
        }
      },
      {
        name: '完结',
        permissson: 'over_b',
        class: { link: 'link2' },
        event: { eventName: 'over', options: [] },
        vIf: function() {
          // if ((row.clearenceType === 1 && row.clearenceStatus === 8 && row.pickUpType === 0) || (row.pickUpSplitDeliveryStatus === 106 && row.pickUpType === 1)) return true
          // return false
          return true
        }
      },
      {
        name: '跟进记录',
        permissson: 'uploadLog_b',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '上传附件',
        permissson: 'upload_b',
        class: { link: 'link' },
        event: { eventName: 'uploadAttachment', options: [] },
        vIf: function() {
          return true
        }
      },
      // {
      //   name: '到港',
      //   permissson: 'arrivalPort_c',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showDateTime', options: ['到港'] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 100) return true
      //     return false
      //   }
      // },
      // {
      //   name: '卸船',
      //   permissson: 'DischargeShip_c',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showDateTime', options: ['卸船'] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 101) return true
      //     return false
      //   }
      // },
      // {
      //   name: '预约',
      //   permissson: 'subscribe_c',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showAppointment', options: [] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 102) return true
      //     return false
      //   }
      // },
      // {
      //   name: '到达',
      //   permissson: 'arrive',
      //   class: { link: 'link2' },
      //   event: { eventName: 'arrive', options: [] },
      //   vIf: function(row) {
      //     if (row.pickUpSplitDeliveryStatus === 103) return true
      //     return false
      //   }
      // },
      // {
      //   name: '到仓',
      //   permissson: 'ArrivalWarehouse',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showWarehouse', options: ['0'] },
      //   vIf: function(row) {
      //     if (
      //       row.pickUpSplitDeliveryStatus === 105 ||
      //       row.pickUpSplitDeliveryStatus === 106
      //     ) { return true }
      //     return false
      //   }
      // },
      // {
      //   name: '出仓',
      //   permissson: 'OutWarehouse',
      //   class: { link: 'link2' },
      //   event: { eventName: 'showWarehouse', options: ['1'] },
      //   vIf: function(row) {
      //     if (
      //       row.pickUpSplitDeliveryStatus === 105 ||
      //       row.pickUpSplitDeliveryStatus === 106
      //     ) { return true }
      //     return false
      //   }
      // },
      {
        name: 'release',
        permissson: 'release',
        class: { link: 'link2' },
        event: { eventName: 'release', options: ['1'] },
        vIf: function(row) {
          if (row.pickUpSplitDeliveryStatus === 107) return true
          return false
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [],
    [
      {
        name: '还原',
        permissson: 'restore',
        class: { link: 'link' },
        event: { eventName: 'handleRestore', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '删除',
        permissson: 'delete',
        class: { link: 'link' },
        event: { eventName: 'handleDelete', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '跟进记录',
        permissson: 'uploadLog_d',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ],
    [
      {
        name: '跟进记录',
        permissson: 'uploadLog_e',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'updateLog', options: [] },
        vIf: function() {
          return true
        }
      },
      {
        name: '清关要素',
        permissson: 'clearance',
        class: { link: 'link', newMessage: 'new-message' },
        event: { eventName: 'clearanceStatus', options: [] },
        vIf: function() {
          return true
        }
      }
    ]
  ],
  workBillCustomerOptions: [
    {
      value: 0,
      label: '操作'
    },
    {
      value: 1,
      label: '财务'
    },
    {
      value: 2,
      label: '客服'
    },
    {
      value: 3,
      label: '销售'
    }
  ],
  priorityLevelOptions: [
    {
      value: 0,
      label: '一般'
    },
    {
      value: 1,
      label: '重要紧急'
    },
    {
      value: 2,
      label: '重要不紧急'
    }
  ],
  workBillStatusOptions: [
    {
      value: 0,
      label: '新增'
    },
    {
      value: 1,
      label: '处理中'
    },
    {
      value: 2,
      label: '通过'
    },
    {
      value: 3,
      label: '关闭'
    },
    {
      value: 4,
      label: '撤回'
    }
  ],
  workBillRemarkPermissionOptions: [
    {
      value: 0,
      label: '所有'
    },
    {
      value: 1,
      label: '对内'
    },
    {
      value: 2,
      label: '对外'
    }
  ],
  classificationOptions: [
    {
      value: 0,
      label: '商业'
    },
    {
      value: 1,
      label: 'MIXED'
    },
    {
      value: 2,
      label: '住宅'
    },
    {
      value: 3,
      label: '未知'
    }
  ],
  sendWayOptions: [
    {
      value: 0,
      label: 'UPS'
    },
    {
      value: 1,
      label: 'FedEx'
    },
    {
      value: 2,
      label: '亚马逊仓'
    },
    {
      value: 3,
      label: '私仓'
    },
    {
      value: 4,
      label: '自提'
    },
    {
      value: 100,
      label: '其它'
    }
  ],
  FMSMBLSendWayTypeOptions: [
    {
      value: 0,
      label: '直送快递商'
    },
    {
      value: 1,
      label: '直送亚马逊仓'
    },
    {
      value: 2,
      label: '直送私仓'
    },
    {
      value: 3,
      label: '回仓自提'
    },
    {
      value: 4,
      label: '回仓快递'
    },
    {
      value: 5,
      label: '回仓卡派亚马逊'
    },
    {
      value: 6,
      label: '回仓卡派私仓'
    },
    {
      value: 7,
      label: '留仓'
    },
    {
      value: 8,
      label: '直送沃尔玛仓'
    },
    {
      value: 9,
      label: '回仓沃尔玛仓'
    }
  ],
  classificationHoldOption: [
    {
      value: 100,
      label: '所有'
    },
    {
      value: 101,
      label: '客户'
    },
    {
      value: 102,
      label: '后台'
    }
  ],
  scanStatusOption: [
    {
      value: 0,
      label: '未扫描'
    },
    {
      value: 1,
      label: '成功'
    },
    {
      value: 2,
      label: '失败'
    }
  ],
  billHoldTypeOption: [
    {
      value: 0,
      label: '主提单'
    },
    {
      value: 1,
      label: '分提单'
    },
    {
      value: 2,
      label: '柜子'
    },
    {
      value: 3,
      label: '订单'
    }
  ],
  sandWayTypeOptions: [
    {
      value: 0,
      label: '整柜拦截'
    },
    {
      value: 1,
      label: '订单暂扣'
    },
    {
      value: 2,
      label: '订单放件'
    },
    {
      value: 3,
      label: '订单拦截改自提'
    },
    {
      value: 4,
      label: '订单拦截换标'
    },
    {
      value: 5,
      label: '拍照'
    },
    {
      value: 6,
      label: '整柜放件'
    },
    {
      value: 1000,
      label: '其他'
    },
    {
      value: 1001,
      label: '其他扣件'
    }
  ],
  fileTypeOption: [
    {
      value: 0,
      label: '提单文件'
    },
    {
      value: 1,
      label: 'AN'
    },
    {
      value: 2,
      label: 'DO'
    },
    {
      value: 3,
      label: 'ISA'
    },
    {
      value: 4,
      label: 'POD'
    },
    // {
    //   value: 5,
    //   label: '提单发票'
    // },
    {
      value: 6,
      label: '后台发票'
    },
    {
      value: 7,
      label: '税金单'
    },
    {
      value: 8,
      label: 'BOL'
    },
    {
      value: 9,
      label: 'ISF'
    },
    {
      value: 10,
      label: '费用证明'
    },
    {
      value: 11,
      label: '少货证明'
    },
    {
      value: 12,
      label: '拆柜清单'
    },
    {
      value: 15,
      label: '电放提单'
    },
    {
      value: 16,
      label: '自有BOL'
    },
    {
      value: 17,
      label: '更新税金单'
    },
    // {
    //   value: 18,
    //   label: '更新发票'
    // },
    {
      value: 19,
      label: '检测报告&认证文件'
    },
    {
      value: 20,
      label: '自留ISA'
    },
    {
      value: 25,
      label: 'OrderListing'
    },
    {
      value: 28,
      label: '供应商拆柜明细'
    },
    {
      value: 29,
      label: 'T86SupplierManifest'
    },
    {
      value: 30,
      label: '导入后台发票'
    },
    {
      value: 1001,
      label: '码头杂费'
    },
    {
      value: 1002,
      label: '提柜费'
    },
    {
      value: 1003,
      label: 'X光费'
    },
    {
      value: 1004,
      label: '销毁费'
    },
    {
      value: 1005,
      label: '3499费'
    },
    {
      value: 1006,
      label: '查验场费'
    },
    {
      value: 1007,
      label: '代付手续费'
    },
    {
      value: 1008,
      label: '查验场仓租'
    },
    {
      value: 1009,
      label: '码头仓租'
    },
    {
      value: 1010,
      label: '柜租'
    },
    {
      value: 99,
      label: '其他'
    }
  ],
  claimPayStatusOption: [
    {
      value: 0,
      label: '待创建人审批'
    },
    {
      value: 5,
      label: '待主管审批'
    },
    {
      value: 10,
      label: '待经理审批'
    },
    {
      value: 15,
      label: '待总监审批'
    },
    {
      value: 20,
      label: '待财务审批'
    },
    {
      value: 25,
      label: '审批结束'
    },
    {
      value: -1,
      label: '审批驳回'
    }
  ],
  claimPayDefrayTypeOption: [
    {
      value: 0,
      label: '清提'
    },
    {
      value: 1,
      label: '派送'
    },
    {
      value: 2,
      label: '派送（预付）'
    }
  ],
  claimPayDefrayStatusOption: [
    {
      value: 0,
      label: '未申付'
    },
    {
      value: 1,
      label: '未支付'
    },
    {
      value: 2,
      label: '已支付'
    }
  ],
  unitOption: [
    {
      value: 0,
      label: '个'
    },
    {
      value: 1,
      label: '分单'
    },
    {
      value: 2,
      label: '柜子'
    },
    {
      value: 3,
      label: '20GP'
    },
    {
      value: 4,
      label: '40HQ'
    },
    {
      value: 5,
      label: '45HQ'
    }
  ],
  checkListStatusOptions: [
    {
      value: 10000,
      label: '全部',
      permissson: 'QB'
    },
    {
      value: 0,
      label: '查验中',
      permissson: 'CYZ'
    },
    {
      value: 1,
      label: '部分放行',
      permissson: 'BFFX'
    },
    {
      value: 2,
      label: '全部放行',
      permissson: 'QBFX'
    },
    {
      value: 3,
      label: '完结',
      permissson: 'WJ'
    }
  ],
  cardInquiryStatusOptions: [
    {
      value: -1,
      label: '全部',
      permissson: 'QB'
    },
    {
      value: 0,
      label: '未报价',
      permissson: 'WBJ'
    },
    {
      value: 5,
      label: '已报价',
      permissson: 'YBJ'
    },
    {
      value: 10,
      label: '已使用',
      permissson: 'YSY'
    }
  ],
  palletOptions: [
    { label: '48*40', value: '48*40' },
    { label: '48*44', value: '48*44' },
    { label: '自定义', value: '自定义' }
  ],
  unitTypeOptions: [
    { label: 'LB/IN', value: 0 },
    { label: 'KG/CM', value: 1 }
  ],
  containertypeOptions: [
    {
      value: '20GP',
      label: '20GP'
    },
    {
      value: '40GP',
      label: '40GP'
    },
    {
      value: '40HQ',
      label: '40HQ'
    },
    {
      value: '40RH',
      label: '40RH'
    },
    {
      value: '40RF',
      label: '40RF'
    },
    {
      value: '40NOR',
      label: '40NOR'
    },
    {
      value: '45HC',
      label: '45HC'
    },
    {
      value: '45HQ',
      label: '45HQ'
    },
    {
      value: '53HQ',
      label: '53HQ'
    }
  ],
  AgencyTypeOptions: [
    {
      value: 0,
      label: '充值审核'
    },
    {
      value: 1,
      label: '订单费用估算异常'
    },
    {
      value: 2,
      label: '提单待确认'
    },
    {
      value: 3,
      label: '预报已发送'
    },
    {
      value: 6,
      label: '税金待确认'
    },
    {
      value: 8,
      label: '提单文件待上传'
    },
    {
      value: 10,
      label: '待发预报'
    }
  ],
  payableTypeOptions: [
    {
      value: 0,
      label: '银付'
    },
    {
      value: 1,
      label: '对冲'
    },
    {
      value: 10,
      label: '其他'
    }
  ],
  feeNameUnitTypeOptions: [
    {
      value: 0,
      label: '箱'
    },
    {
      value: 1,
      label: '单'
    },
    {
      value: 2,
      label: '件'
    },
    {
      value: 3,
      label: '提单'
    },
    {
      value: 4,
      label: '板'
    },
    {
      value: 5,
      label: '磅'
    },
    {
      value: 6,
      label: '小时'
    },
    {
      value: 7,
      label: '天'
    },
    {
      value: 8,
      label: '周'
    },
    {
      value: 9,
      label: '次'
    },
    {
      value: 10,
      label: '票'
    },
    {
      value: 11,
      label: '卡车'
    },
    {
      value: 12,
      label: '张'
    },
    {
      value: 13,
      label: '%'
    },
    {
      value: 14,
      label: 'KG'
    },
    {
      value: 15,
      label: '个'
    },
    {
      value: 16,
      label: '板/天'
    },
    {
      value: 17,
      label: '板/周'
    },
    {
      value: 18,
      label: '柜'
    }
  ],
  otherStatusOptions: [
    {
      value: '0',
      label: '草稿箱'
    },
    {
      value: '1',
      label: '预报已发送'
    },
    {
      value: '2',
      label: '预报处理中'
    },
    {
      value: '3',
      label: '已完成'
    },
    {
      value: '4',
      label: '已出账'
    },
    {
      value: '-1',
      label: '已作废'
    }
  ],
  openClaimStatusOptions: [
    {
      value: '',
      label: '全部',
      permissson: 'QB'
    },
    {
      value: 0,
      label: '待审核',
      permissson: 'DSH'
    },
    {
      value: 1,
      label: '处理中',
      permissson: 'CLZ'
    },
    {
      value: 3,
      label: '已申付',
      permissson: 'YSF'
    },
    {
      value: 2,
      label: '完结',
      permissson: 'WJ'
    }
  ],
  clearenceStatusOptions: [
    //  5 = TaxesPaddingComfirm(), 6 = CustomsClearence(), 7 = ClearenceHold(), 8 = ClearenceReleased(/)
    {
      value: 0,
      label: '无'
    },
    {
      value: 2,
      label: '待发预报'
    },
    {
      value: 3,
      label: '预报已发送'
    },
    {
      value: 4,
      label: '预报已接受'
    },
    {
      value: 5,
      label: '税金待确认'
    },
    {
      value: 6,
      label: '清关中'
    },
    {
      value: 7,
      label: '查验中'
    },
    {
      value: 8,
      label: '已放行'
    }
  ],
  departureStatusOptions: [
    // 0 = Departured(离港), 1 = Arrived(已到港/到达), 2 = Discharge(卸船), 3 = PickUp(提柜), 4 = EmptyReturned(), -1 = None(无)
    {
      value: 0,
      label: '离港'
    },
    {
      value: 1,
      label: '已到港/到达'
    },
    {
      value: 2,
      label: '卸船'
    },
    {
      value: 3,
      label: '提柜'
    },
    {
      value: 4,
      label: '还空柜'
    },
    {
      value: 5,
      label: '无'
    }
  ],
  importerStatusOptions: [
    {
      value: 1,
      label: '买磅中'
    },
    {
      value: 2,
      label: '未备案'
    },
    {
      value: 3,
      label: '注销中'
    },
    {
      value: 4,
      label: '已备案'
    },
    {
      value: 5,
      label: '已失效'
    },
    {
      value: 7,
      label: '已超磅'
    },
    {
      value: 8,
      label: '已注销'
    },
    {
      value: 9,
      label: '呆滞'
    }
  ],
  userTypeOptions: [
    {
      value: 0,
      label: '游客'
    },
    {
      value: 101,
      label: '操作人员'
    },
    {
      value: 166,
      label: '管理员'
    },
    {
      value: 200,
      label: '操作人员'
    },
    {
      value: 201,
      label: '财务-应收'
    },
    {
      value: 202,
      label: '已超财务-应付磅'
    },
    {
      value: 203,
      label: '财务-主管'
    },
    {
      value: 204,
      label: '业务员'
    },
    {
      value: 266,
      label: '超级管理员'
    }
  ],
  cargoReleaseProcessingOptions: [
    { label: 'Certify via ACE', value: 'Certify via ACE' },
    { label: 'Not to be Certifed', value: 'Not to be Certifed' }
    // { label: 'Certify via ACS', value: 'Certify via ACS' }
  ],
  BondTypeOptions: [
    { label: '00 - No Bond Required', value: 0 },
    { label: '08 - ContinuousBond', value: 8 },
    { label: '09 - Single Transaction Bond', value: 9 }
  ],
  bondWaiverReasonCodeOptions: [
    {
      label: '995 - Supplemental Duty Bills on Vessel Repair Entries',
      value: '995'
    },
    { label: '996 - Fines, Penalty, or Liquidated Damage Bills', value: '996' },
    { label: '997 - All Other Contingent Bills', value: '997' },
    { label: '998 - Bills Secured - Other than Surety', value: '998' },
    { label: '999 - No Surety, Unsecured Bills', value: '999' }
  ],
  secondNameTypeOptions: [
    { label: 'Alternative Addressee', value: 'Alternative Addressee' },
    { label: 'Doing Business As', value: 'Doing Business As' },
    { label: 'Division', value: 'Division' },
    { label: 'Formerly Known As', value: 'Formerly Known As' },
    {
      label: 'Formerly Doing Business As',
      value: 'Formerly Doing Business As'
    },
    { label: 'Alias (Other Names Used)', value: 'Alias (Other Names Used)' }
  ],
  irsTaxCodeOptions: [
    {
      label: '016-liquors and cordials, distilled',
      value: '016-liquors and cordials, distilled'
    },
    {
      label: '016-wines over 24 percent alcohol',
      value: '016-wines over 24 percent alcohol'
    },
    { label: '016-distilled spirits', value: '016-distilled spirits' },
    {
      label: '017-still wines >= 16% & < 21% alcohol',
      value: '017-still wines >= 16% & < 21% alcohol'
    },
    {
      label: '017-still wines >= 21% & < 24% alcohol',
      value: '017-still wines >= 21% & < 24% alcohol'
    },
    {
      label: '017-rice wine or sake, fermented',
      value: '017-rice wine or sake, fermented'
    },
    {
      label: '017-champagne and sparkling wines',
      value: '017-champagne and sparkling wines'
    },
    {
      label: '017-still wines < 16% alcohol',
      value: '017-still wines < 16% alcohol'
    },
    {
      label: '017-artificial carbonated wines',
      value: '017-artificial carbonated wines'
    },
    {
      label: '017-hard cider reduced rate',
      value: '017-hard cider reduced rate'
    },
    {
      label: '018-large cigars exceeding $235.294 per k.',
      value: '018-large cigars exceeding $235.294 per k.'
    },
    {
      label: '018-pipe tobacco classified in 2403',
      value: '018-pipe tobacco classified in 2403'
    },
    { label: '018-large cigars', value: '018-large cigars' },
    {
      label: '018-small cigarettes up to 3 pounds per k.',
      value: '018-small cigarettes up to 3 pounds per k.'
    },
    {
      label: '018-snuff classified in 2403.99.00',
      value: '018-snuff classified in 2403.99.00'
    },
    { label: '018-roll your own tobacco', value: '018-roll your own tobacco' },
    {
      label: '018-small cigars up to 3 pounds per k.',
      value: '018-small cigars up to 3 pounds per k.'
    },
    {
      label: '018-large cigarettes up to 3 pounds per k.',
      value: '018-large cigarettes up to 3 pounds per k.'
    },
    {
      label: '018-large cigars up to $235.294 per k.',
      value: '018-large cigars up to $235.294 per k.'
    },
    {
      label: '018-chewing tobacco classified in 2403.99.00',
      value: '018-chewing tobacco classified in 2403.99.00'
    },
    { label: '022-beer', value: '022-beer' },
    { label: '022-beer reduced rate', value: '022-beer reduced rate' },
    { label: '022-perfumes', value: '022-perfumes' },
    { label: '022-cigarette papers', value: '022-cigarette papers' },
    { label: '022-cigarette tubes', value: '022-cigarette tubes' }
  ],
  zoneStatusOptions: [
    {
      label: 'Privileged Foreign Merchandise',
      value: 'Privileged Foreign Merchandise'
    },
    { label: 'Domestic Merchandise', value: 'Domestic Merchandise' },
    {
      label: 'Non-privileged Foreign Status',
      value: 'Non-privileged Foreign Status'
    }
  ],
  addressPartOptions: [
    { label: 'StreetNumber', value: '1' },
    { label: 'StreetName', value: '2' },
    { label: 'POBoxNumber', value: '5' },
    { label: 'BuildingName', value: '12' },
    { label: 'ApartmentNumber', value: '13' },
    { label: 'SuiteNumber', value: '14' },
    { label: 'UnstructuredStreetAddress', value: '15' },
    { label: 'AssociationName', value: '28' },
    { label: 'Pier', value: '30' },
    { label: 'Wing', value: '31' },
    { label: 'FloorNumber', value: '32' },
    { label: 'Room', value: '35' },
    { label: 'Unit', value: '37' },
    { label: 'CrossStreet', value: '57' },
    { label: 'BuildingNumber', value: '58' }
  ],
  disclaimReasonOptions: [
    { label: 'A - Product is not regulated by this agency', value: 'A' },
    { label: 'B - Data is not required per agency guidance', value: 'B' },
    { label: 'C - Data filed through other agency means', value: 'C' },
    { label: 'D - Data filed through paper', value: 'D' }
  ],
  quantityUnitOptions: [
    { label: 'Grams', value: 'G' },
    { label: 'Centigrams', value: 'CG' },
    { label: 'Kilograms', value: 'KG' },
    { label: 'Meters', value: 'M' },
    { label: 'Square Meters', value: 'M2' },
    { label: 'Cubic Meters', value: 'M3' },
    { label: 'Centiliters', value: 'CLR' },
    { label: 'Centimeters', value: 'CM' },
    { label: 'Square Centimeters', value: 'CM2' },
    { label: 'Cubic Centimeters', value: 'CM3' },
    { label: 'Kiloliters', value: 'KL' },
    { label: 'Liters', value: 'L' },
    { label: 'Milliliters', value: 'ML' },
    { label: 'Millimeters', value: 'MM' },
    { label: 'Square Millimeters', value: 'MM2' },
    { label: 'Cubic Millimeters', value: 'MM3' }
  ],
  programCodeOptioons1: [
    { label: 'PS1 - Registered Pesticides', value: 'PS1' },
    { label: 'PS2 - Pesticides-Devices', value: 'PS2' },
    { label: 'PS3 - Pesticides-Other', value: 'PS3' }
  ],
  programCodeOptioons2: [
    { label: 'AAC - Animal Care', value: 'AAC' },
    { label: 'ABS - Biotech Regulatory Services', value: 'ABS' },
    { label: 'APQ - Plant Protection/Quarantine', value: 'APQ' },
    { label: 'AVS - Veterinary Services', value: 'AVS' }
  ],
  programCodeOptioons3: [
    { label: 'MVS - Motor Vehicles', value: 'MVS' },
    {
      label: 'REI - Regulated Motor Vehicle Equipment subject to FMVSS',
      value: 'REI'
    },
    {
      label: 'TPE - Replacement Motor Vehicle Equipment subject to FMVTPS',
      value: 'TPE'
    },
    {
      label: 'OEI - Other Motor Vehicle Equipment NOT subject to FMVSS/FMVTPS',
      value: 'OEI'
    },
    {
      label: 'OFF - Vehicles or Equipment NOT for use on public roads',
      value: 'OFF'
    }
  ],
  clearanceModesOptions: [
    {
      value: 1,
      label: 'T01'
    },
    {
      value: 2,
      label: 'T11'
    }
  ],
  invoiceReviewTypeOptions: [
    {
      value: 0,
      label: '正常审单'
    },
    {
      value: 1,
      label: 'AI审单'
    }
  ],
  //  0 = TaxLarge(税金过高), 1 = TaxLower(税金过低), 2 = TotalLarge(总价值过高), 3 = TotalLower(总价值过低), 4 = WeightLarge(重量过高), 5 = WeightLower(重量过低), 6 = Other(其他)
  invoiceRetryTypeOptions: [
    {
      value: 0,
      label: '税金过高'
    },
    {
      value: 1,
      label: '税金过低'
    },
    {
      value: 2,
      label: '总价值过高'
    },
    {
      value: 3,
      label: '总价值过低'
    },
    {
      value: 4,
      label: '重量过高'
    },
    {
      value: 5,
      label: '重量过低'
    },
    {
      value: 6,
      label: '其他'
    }
  ],
  cookieKey: 'accessToken' // cookie标识
}
